export default __webpack_public_path__ + "static/media/amazon.e9f11325.svg";